module.exports = __webpack_public_path__ + "static/img/part4-dis.59f09b4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/part4-dis.png
// module id = 8Z0y
// module chunks = 1